import { ExternalRecommendationsState } from '../reducers/externalRecommendationsReducer';

export default function getExternalRecommendations(content: ExternalRecommendationsState) {
    const { response, error } = content;
    if (!response || !response.body || error) return null;

    return response.body;
}